///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthReactiveInputBase } from './input-base';
import { GtthInputTypesEnum } from './input-types.enum';

export class GtthReactiveTextbox extends GtthReactiveInputBase<string> {
    controlType = GtthInputTypesEnum.TEXTBOX;
    type: string;
    step: number;
    min: number;
    max: number;
    minLength: number;
    maxLength: number;

    constructor(options: GtthReactiveTextbox) {
        super(options);
        this.type = options.type || 'text';
        this.step = options.step || 1;
        this.min = options.min;
        this.max = options.max;
        this.minLength = options.minLength || 0;
        this.maxLength = options.maxLength || 999999;
    }
}
